import { render } from "./FacilityAddressModal.vue?vue&type=template&id=56fd989e&scoped=true&ts=true"
import script from "./FacilityAddressModal.vue?vue&type=script&lang=ts"
export * from "./FacilityAddressModal.vue?vue&type=script&lang=ts"

import "./FacilityAddressModal.vue?vue&type=style&index=0&id=56fd989e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56fd989e"]])

export default __exports__